module.exports = __webpack_public_path__ + "img/Jose-Manuel-Cosio.56759ea7.png";